import React from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from 'components/Icon'
import DropdownInput from 'components/DropdownInput'
import Button from 'components/Button'
import CheckboxGroup from 'components/CheckboxGroup'
import { Waypoint } from 'react-waypoint'
import messages from './messages'
import styles from './FilterableList.scss'

interface FilterableListProps {
  items?: any[]
  filterKey: string
  filterOptions?: any[]
  filterSelections?: any[]
  onFilter?: (selections: any[]) => void
  renderItem: (item: any) => React.ReactNode
  onScroll?: () => void
  numberOfTotalItems?: number
  numberOfDocumentedItems?: number
}

function FilterableList({
  items = [],
  filterKey,
  filterOptions,
  filterSelections = [],
  onFilter = () => {},
  renderItem,
  onScroll = () => {},
  numberOfTotalItems = 0,
  numberOfDocumentedItems = 0,
}: FilterableListProps) {
  const FilterButton = () => (
    <Button buttonType='icon' className={styles.filterButton}>
      <Icon name='filters' size='regular' />
    </Button>
  )

  const displayedItems = items

  const getNumberOfItemsByType = () => ({
    review: numberOfTotalItems,
    coin: numberOfDocumentedItems,
  })

  const headers = getNumberOfItemsByType()

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.actions}>
          {filterOptions && (
            <DropdownInput
              disableSearch
              hasSelectAll
              options={filterOptions}
              selections={filterSelections || []}
              onChange={onFilter}
              buttonRenderer={FilterButton}
              className={styles.filter}
            />
          )}
          </div>
          <div className={styles.title}>
            <FormattedMessage {...messages.documentedActivity} values={{ count: numberOfTotalItems }} tagName='span' />
          </div>
          <div className={styles.numbers}>
            <CheckboxGroup
              type='regular'
              isRow
              withIcons
              name='activityFilter'
              options={Object.keys(headers).map(key => `${key}`)}
              customValues={[`Documented Activity (${headers.review})`, `Documented Revenue (${headers.coin})`]}
              selections={[]}
              onChange={(option) => {}}
            />
          </div>
        </h3>
      </header>
      <ul className={styles.items}>
        {displayedItems.map((item, index) => (
          <li key={index} className={styles.item}>
            {renderItem(item)}
            {index === displayedItems.length - 4 && <Waypoint onEnter={onScroll} />}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FilterableList

